module.exports = __webpack_public_path__ + "static/media/background.cd07214f.png";